export default "__VITE_PUBLIC_ASSET__63e9d4ae__"